import { render, staticRenderFns } from "./TransporterView.vue?vue&type=template&id=31fbe359&"
import script from "./TransporterView.vue?vue&type=script&lang=js&"
export * from "./TransporterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports